import { useInView } from "react-intersection-observer";
import {
  motion,
  useViewportScroll,
  useTransform,
} from "framer-motion";
import Espontaneo from "../../../images/scroll-fixed/slide1/se-espontaneo.png";
import Encuentrate from "../../../images/scroll-fixed/slide2/encuentrate-con-duda.svg";
import MundoPremium from "../../../images/scroll-fixed/slide3/mundo-premium.svg";
import bgSlide3 from "../../../images/scroll-fixed/slide3/scene3-bg-channels.png";
import { Link } from "react-router-dom";

const ScrollFixedMobile = () => {
  const { ref: bgRef, inView: isVisibleBg } = useInView({
    triggerOnce: true,
  });
  const { scrollYProgress } = useViewportScroll();
  const yImg1 = useTransform(scrollYProgress, [0, 0.09, 0.15], [0, -100, -300]);
  const yTxt1 = useTransform(scrollYProgress, [0, 0.09, 0.15], [0, 100, 200]);
  const yImg2 = useTransform(
    scrollYProgress,
    [0, 0.13, 0.18, 26],
    [0, -150, -100, -200]
  );
  const yTxt2 = useTransform(
    scrollYProgress,
    [0, 0.15, 0.28, 0.36],
    [0, 100, 200, 300]
  );
  const yImg3 = useTransform(
    scrollYProgress,
    [0, 0.22, 0.26, 32],
    [0, -150, -75, 100]
  );
  const yTxt3 = useTransform(scrollYProgress, [0, 0.26, 0.44], [0, 100, 120]);

  return (
    <div className="container-scroll-fixed-mobile">
      {/* BACKGROUND */}
      <motion.div
        ref={bgRef}
        className="background"
        initial={{
          opacity: 0,
        }}
        animate={
          isVisibleBg && {
            opacity: 1,
          }
        }
        transition={{ duration: 2 }}
      >
        <div className="circle1"></div>
        <div className="circle2"></div>
        <div className="circle3"></div>
        <div className="circle4"></div>
        <div className="circle5"></div>
      </motion.div>
      <div className="scroll-fixed-mobile">
        {/* SCENE 1 */}
        <div className="scene scene1">
          <motion.div className="container-images" style={{ marginTop: yImg1 }}>
            <motion.div
              className="image1 backg-img"
              initial={{
                y: 200,
                opacity: 0,
              }}
              animate={
                isVisibleBg && {
                  y: 0,
                  opacity: 1,
                }
              }
              transition={{ duration: 2 }}
            />
            <motion.div
              className="image3 backg-img"
              initial={{
                y: 200,
                opacity: 0,
              }}
              animate={
                isVisibleBg && {
                  y: 0,
                  opacity: 1,
                }
              }
              transition={{ duration: 2 }}
            />
            <motion.div
              className="image4 backg-img"
              initial={{
                y: 200,
                opacity: 0,
              }}
              animate={
                isVisibleBg && {
                  y: 0,
                  opacity: 1,
                }
              }
              transition={{ duration: 2 }}
            />
            <motion.div
              className="image5 backg-img"
              initial={{
                y: 200,
                opacity: 0,
              }}
              animate={
                isVisibleBg && {
                  y: 0,
                  opacity: 1,
                }
              }
              transition={{ duration: 2 }}
            />
          </motion.div>
          <motion.div
            className="text-content"
            style={{ marginBottom: yTxt1 }}
            initial={{
              y: 200,
              opacity: 0,
            }}
            animate={
              isVisibleBg && {
                y: 0,
                opacity: 1,
              }
            }
            transition={{ duration: 2 }}
          >
            <img className="img1" src={Espontaneo} />
            <h2>
              TIÉNTATE CON <font>XD NEO</font>
            </h2>
            <span className="text-down">
              Scroll
              <svg
                width="20"
                height="33"
                viewBox="0 0 20 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <motion.rect
                  x="8"
                  y="6"
                  width="4"
                  height="4"
                  rx="4"
                  fill="white"
                  animate={{ y: [9, 0, 9], opacity: [0, 1, 0] }}
                  transition={{
                    duration: 1.9,
                    times: [0.1, 0.5, 0.9],
                    yoyo: Infinity,
                  }}
                />
                <motion.rect
                  x="1"
                  y="1"
                  width="18"
                  height="31"
                  rx="9"
                  stroke="white"
                  stroke-width="2"
                />
              </svg>
              down
            </span>
          </motion.div>
        </div>
        <br />
        {/* SCENE 2 */}
        <motion.div className="scene scene2">
          <motion.div className="channels" style={{ marginTop: yImg2 }}>
            <div className="channel logo1">
              <div className="img"></div>
            </div>
            <div className="channel logo2">
              <div className="img"></div>
            </div>
            <div className="channel logo3">
              <div className="img"></div>
            </div>
            <div className="channel logo4">
              <div className="img"></div>
            </div>
            <div className="channel logo5">
              <div className="img"></div>
            </div>
            <div className="channel logo6">
              <div className="img"></div>
            </div>
            <div className="channel logo7">
              <div className="img"></div>
            </div>
          </motion.div>
          <motion.div className="text-scene" style={{ marginBottom: yTxt2 }}>
            <img className="encuentrate" src={Encuentrate} />
            <h2 className="text-title">
              DE NO SABER CON CUÁL DE LOS MÁS DE 100 CANALES ENTRETENERTE.
            </h2>
            <div className="btns-scene">
              <Link to="/canales" className="button button-primary">
                Ver canales
              </Link>
              <Link to="/guia" className="button button-transparent">
                Explorar guía
              </Link>
            </div>
          </motion.div>
        </motion.div>
        <br />
        {/* SCENE 3 */}
        <motion.div className="scene scene3">
          <motion.div className="img-scene3" style={{ marginTop: yImg3 }}>
            <img
              src={bgSlide3}
              alt="3 Logos de canales, HBO, Discovery+ y Golden"
            />
          </motion.div>
          <motion.div className="text-scene" style={{ marginBottom: yTxt3 }}>
            <img className="mundo-premium" src={MundoPremium} />
            <h2 className="text-title">
              PARA DISFRUTAR DEL CONTENIDO MÁS EXCLUSIVO DE TODOS.
            </h2>
            <div className="channels">
              <div className="channel margin">
                <div className="logo1"></div>
              </div>
              <div className="channel">
                <div className="logo2"></div>
              </div>
            </div>
            <div className="btns-scene">
              <Link to="/canales" className="button button-primary">
                Ver canales
              </Link>
              <Link to="/guia" className="button button-transparent">
                Explorar guía
              </Link>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default ScrollFixedMobile;
